// Generated by Argon compiler — do not edit by hand.
// CSR store output: reactive shared state with no runtime dependency.

const __argonSubs = new Map();

function __argonNotify(key) {
  for (const fn of __argonSubs.get(key) ?? []) fn();
}

export function argonSubscribe(key, fn) {
  let set = __argonSubs.get(key);
  if (!set) __argonSubs.set(key, set = new Set());
  set.add(fn);
  return () => {
    set.delete(fn);
    if (set.size === 0) __argonSubs.delete(key);
  };
}

export const threadView = {};
let __argon_threadView_active = false;
Object.defineProperty(threadView, "active", {
  enumerable: true,
  get() { return __argon_threadView_active; },
  set(value) {
    if (Object.is(__argon_threadView_active, value)) return;
    __argon_threadView_active = value;
    __argonNotify("threadView.active");
  },
});

let __argon_threadView_turns = [];
Object.defineProperty(threadView, "turns", {
  enumerable: true,
  get() { return __argon_threadView_turns; },
  set(value) {
    if (Object.is(__argon_threadView_turns, value)) return;
    __argon_threadView_turns = value;
    __argonNotify("threadView.turns");
  },
});

let __argon_threadView_running = false;
Object.defineProperty(threadView, "running", {
  enumerable: true,
  get() { return __argon_threadView_running; },
  set(value) {
    if (Object.is(__argon_threadView_running, value)) return;
    __argon_threadView_running = value;
    __argonNotify("threadView.running");
  },
});

let __argon_threadView_placeholder = "";
Object.defineProperty(threadView, "placeholder", {
  enumerable: true,
  get() { return __argon_threadView_placeholder; },
  set(value) {
    if (Object.is(__argon_threadView_placeholder, value)) return;
    __argon_threadView_placeholder = value;
    __argonNotify("threadView.placeholder");
  },
});

let __argon_threadView_models = [];
Object.defineProperty(threadView, "models", {
  enumerable: true,
  get() { return __argon_threadView_models; },
  set(value) {
    if (Object.is(__argon_threadView_models, value)) return;
    __argon_threadView_models = value;
    __argonNotify("threadView.models");
  },
});

let __argon_threadView_selectedModel = "";
Object.defineProperty(threadView, "selectedModel", {
  enumerable: true,
  get() { return __argon_threadView_selectedModel; },
  set(value) {
    if (Object.is(__argon_threadView_selectedModel, value)) return;
    __argon_threadView_selectedModel = value;
    __argonNotify("threadView.selectedModel");
  },
});

let __argon_threadView_selectedModelLabel = "Choose model";
Object.defineProperty(threadView, "selectedModelLabel", {
  enumerable: true,
  get() { return __argon_threadView_selectedModelLabel; },
  set(value) {
    if (Object.is(__argon_threadView_selectedModelLabel, value)) return;
    __argon_threadView_selectedModelLabel = value;
    __argonNotify("threadView.selectedModelLabel");
  },
});

let __argon_threadView_selectedModelReasoningEffort = "";
Object.defineProperty(threadView, "selectedModelReasoningEffort", {
  enumerable: true,
  get() { return __argon_threadView_selectedModelReasoningEffort; },
  set(value) {
    if (Object.is(__argon_threadView_selectedModelReasoningEffort, value)) return;
    __argon_threadView_selectedModelReasoningEffort = value;
    __argonNotify("threadView.selectedModelReasoningEffort");
  },
});

let __argon_threadView_attachments = [];
Object.defineProperty(threadView, "attachments", {
  enumerable: true,
  get() { return __argon_threadView_attachments; },
  set(value) {
    if (Object.is(__argon_threadView_attachments, value)) return;
    __argon_threadView_attachments = value;
    __argonNotify("threadView.attachments");
  },
});

let __argon_threadView_approvalMessage = "";
Object.defineProperty(threadView, "approvalMessage", {
  enumerable: true,
  get() { return __argon_threadView_approvalMessage; },
  set(value) {
    if (Object.is(__argon_threadView_approvalMessage, value)) return;
    __argon_threadView_approvalMessage = value;
    __argonNotify("threadView.approvalMessage");
  },
});

let __argon_threadView_quizQuestion = "";
Object.defineProperty(threadView, "quizQuestion", {
  enumerable: true,
  get() { return __argon_threadView_quizQuestion; },
  set(value) {
    if (Object.is(__argon_threadView_quizQuestion, value)) return;
    __argon_threadView_quizQuestion = value;
    __argonNotify("threadView.quizQuestion");
  },
});

let __argon_threadView_quizOptions = [];
Object.defineProperty(threadView, "quizOptions", {
  enumerable: true,
  get() { return __argon_threadView_quizOptions; },
  set(value) {
    if (Object.is(__argon_threadView_quizOptions, value)) return;
    __argon_threadView_quizOptions = value;
    __argonNotify("threadView.quizOptions");
  },
});

let __argon_threadView_quizSubmitting = false;
Object.defineProperty(threadView, "quizSubmitting", {
  enumerable: true,
  get() { return __argon_threadView_quizSubmitting; },
  set(value) {
    if (Object.is(__argon_threadView_quizSubmitting, value)) return;
    __argon_threadView_quizSubmitting = value;
    __argonNotify("threadView.quizSubmitting");
  },
});

let __argon_threadView_error = "";
Object.defineProperty(threadView, "error", {
  enumerable: true,
  get() { return __argon_threadView_error; },
  set(value) {
    if (Object.is(__argon_threadView_error, value)) return;
    __argon_threadView_error = value;
    __argonNotify("threadView.error");
  },
});

export function argonSnapshot() {
  return {
    threadView: { active: threadView.active, turns: threadView.turns, running: threadView.running, placeholder: threadView.placeholder, models: threadView.models, selectedModel: threadView.selectedModel, selectedModelLabel: threadView.selectedModelLabel, selectedModelReasoningEffort: threadView.selectedModelReasoningEffort, attachments: threadView.attachments, approvalMessage: threadView.approvalMessage, quizQuestion: threadView.quizQuestion, quizOptions: threadView.quizOptions, quizSubmitting: threadView.quizSubmitting, error: threadView.error },
  };
}

export function argonHydrate(snapshot) {
  if (!snapshot) return;
  if (snapshot.threadView) {
    if ("active" in snapshot.threadView) threadView.active = snapshot.threadView.active;
    if ("turns" in snapshot.threadView) threadView.turns = snapshot.threadView.turns;
    if ("running" in snapshot.threadView) threadView.running = snapshot.threadView.running;
    if ("placeholder" in snapshot.threadView) threadView.placeholder = snapshot.threadView.placeholder;
    if ("models" in snapshot.threadView) threadView.models = snapshot.threadView.models;
    if ("selectedModel" in snapshot.threadView) threadView.selectedModel = snapshot.threadView.selectedModel;
    if ("selectedModelLabel" in snapshot.threadView) threadView.selectedModelLabel = snapshot.threadView.selectedModelLabel;
    if ("selectedModelReasoningEffort" in snapshot.threadView) threadView.selectedModelReasoningEffort = snapshot.threadView.selectedModelReasoningEffort;
    if ("attachments" in snapshot.threadView) threadView.attachments = snapshot.threadView.attachments;
    if ("approvalMessage" in snapshot.threadView) threadView.approvalMessage = snapshot.threadView.approvalMessage;
    if ("quizQuestion" in snapshot.threadView) threadView.quizQuestion = snapshot.threadView.quizQuestion;
    if ("quizOptions" in snapshot.threadView) threadView.quizOptions = snapshot.threadView.quizOptions;
    if ("quizSubmitting" in snapshot.threadView) threadView.quizSubmitting = snapshot.threadView.quizSubmitting;
    if ("error" in snapshot.threadView) threadView.error = snapshot.threadView.error;
  }
}

const __argonPayload = globalThis.document?.querySelector?.('script[type="application/json"][data-argon-stores]');
if (__argonPayload?.textContent) argonHydrate(JSON.parse(__argonPayload.textContent));
